import { useQuery } from "react-query";
import ApiCall from "../../api/network";

const getWebSEttings = async (id) => {
  const webSettings = {
    method: "GET",
    url: `/organizer-settings/${id}`,
    useAuth: true,
  };
  return (await id) && ApiCall.any(webSettings);
};

export const useWebSettings = (id) => {
  return useQuery(["webSettings", id], () => getWebSEttings(id),{
    staleTime: 60 * (60 * 1000),
  });
};
